<template lang="pug">
	.rating-container
		span.rating-title(v-if="title") {{ title }}
		StarRating(
			:increment="increment"
			:rating="rating"
			:max-rating="maxRating"
			:star-points="starPoints"
			:read-only="readOnly"
			:show-rating="showRating"
			:fixed-points="fixedPoints"
			:rtl="rtl"
			:round-start-rating="roundStartRating"
			:star-size="starSize"
			:inactive-color="inactiveColor"
			:active-color="activeColor"
			:border-color="borderColor"
			:border-width="borderWidth"
			:padding="padding"
			:rounded-corners="roundedCorners"
			@rating-selected="ratingSelected"
		)

</template>

<script>
export default {
	name  : "Rating",
	props : {
		title: {
			type: String
		},
		increment: {
			type    : Number,
			default : 1
		},
		rating: {
			type    : Number,
			default : 0
		},
		maxRating: {
			type    : Number,
			default : 5
		},
		starPoints: {
			type: Array
		},
		readOnly: {
			type    : Boolean,
			default : false
		},
		showRating: {
			type    : Boolean,
			default : true
		},
		fixedPoints: {
			type    : Object,
			default : null
		},
		rtl: {
			type    : Boolean,
			default : false
		},
		roundStartRating: {
			type    : Boolean,
			default : true
		},
		starSize: {
			type    : Number,
			default : 50
		},
		inactiveColor: {
			type    : String,
			default : "#d8d8d8"
		},
		activeColor: {
			type    : String,
			default : "#ffd055"
		},
		borderColor: {
			type    : String,
			default : "#999"
		},
		borderWidth: {
			type    : Number,
			default : 0
		},
		padding: {
			type    : Number,
			default : 0
		},
		roundedCorners: {
			type    : Boolean,
			default : false
		}
	},
	methods: {
		ratingSelected(value) {
			this.$emit("rating-selected", value)
		}
	}
}
</script>
<style scoped>

.rating-container {

}

.rating-title {

}

</style>

